export function LogoMark({ size = 40, className, rounded = 12 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}
      role="img" aria-label="NUSTAMAC WALO logo">
      <defs>
        <linearGradient id="nw-grad" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor="hsl(142 40% 32%)" />
          <stop offset="1" stopColor="hsl(142 48% 15%)" />
        </linearGradient>
      </defs>
      <rect width="48" height="48" rx={rounded} fill="url(#nw-grad)" />
      {/* double roofline forming a W / rooftops */}
      <path d="M9 30 L16.5 17 L24 26 L31.5 17 L39 30" stroke="white" strokeWidth="3"
        strokeLinecap="round" strokeLinejoin="round" />
      {/* ground / foundation bar */}
      <rect x="11" y="33.5" width="26" height="3" rx="1.5" fill="white" fillOpacity="0.9" />
      {/* terracotta beacon (health dot) */}
      <circle cx="24" cy="26" r="2.7" fill="hsl(15 75% 62%)" />
    </svg>
  );
}
